import type { TaskClassification, TaskPlan } from "../task-workflow";

export const demoTaskPlans: Record<Exclude<TaskClassification, "informativa">, TaskPlan> = {
  operativa: {
    objective: "Preparare una checklist dei documenti necessari per Alfa S.r.l.",
    expectedResult: "Una checklist pronta da condividere con il team.",
    activities: ["Verificare la pratica Alfa S.r.l.", "Raccogliere i documenti già disponibili", "Segnalare gli elementi mancanti"],
  },
  complessa: {
    objective: "Organizzare il lavoro di candidatura per un’opportunità di finanziamento.",
    expectedResult: "Un piano ordinato con responsabilità e prossime scadenze.",
    activities: ["Analizzare requisiti e scadenze", "Collegare documenti e responsabili", "Preparare il riepilogo per l’approvazione"],
  },
};
